const VisaIcon = ({ ...props }) => {
  return (
    <svg
      width="55"
      height="30"
      viewBox="0 0 55 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.09961"
        y="0.294922"
        width="53.5212"
        height="29.0316"
        fill="#070225"
        stroke="white"
        strokeWidth="0.5"
      />
      <mask
        id="mask0_5761_224"
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="38"
        height="13"
      >
        <path
          d="M28.0192 12.7083C27.9981 14.3729 29.5027 15.3018 30.6361 15.8541C31.8006 16.4208 32.1918 16.7842 32.1873 17.2909C32.1785 18.0665 31.2584 18.4088 30.3972 18.4221C28.8948 18.4455 28.0214 18.0165 27.3269 17.6921L26.7858 20.2245C27.4825 20.5456 28.7726 20.8257 30.1105 20.8379C33.2508 20.8379 35.3054 19.2878 35.3165 16.8842C35.3287 13.8339 31.0973 13.665 31.1261 12.3016C31.1361 11.8882 31.5306 11.4471 32.3951 11.3348C32.823 11.2782 34.0042 11.2348 35.3432 11.8515L35.8688 9.40133C35.1487 9.13909 34.2231 8.88795 33.0708 8.88795C30.1149 8.88795 28.0359 10.4592 28.0192 12.7083ZM40.9192 9.09908C40.3458 9.09908 39.8625 9.43356 39.6469 9.94694L35.1609 20.6579H38.299L38.9235 18.9322H42.7583L43.1205 20.6579H45.8863L43.4728 9.09908H40.9192ZM41.3581 12.2216L42.2638 16.562H39.7836L41.3581 12.2216ZM24.2144 9.09908L21.7409 20.6579H24.7311L27.2036 9.09908H24.2144ZM19.7907 9.09908L16.6782 16.9664L15.4192 10.277C15.2714 9.53023 14.688 9.09908 14.0402 9.09908H8.95198L8.88086 9.43467C9.9254 9.66135 11.1122 10.0269 11.8311 10.4181C12.2712 10.657 12.3967 10.8659 12.5412 11.4337L14.9258 20.6579H18.0861L22.931 9.09908H19.7907Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5761_224)">
        <path
          d="M5.00586 10.3141L41.4672 -3.11378L49.762 19.41L13.301 32.8379"
          fill="url(#paint0_linear_5761_224)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5761_224"
          x1="12.2331"
          y1="20.4736"
          x2="43.4208"
          y2="8.98769"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default VisaIcon
